// extracted by mini-css-extract-plugin
module.exports = {"form":"AddInvite_form__1-q9Y"};